import React, { useEffect } from 'react'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import AdapterJalaali from '@date-io/jalaali'
import moment from 'moment-jalaali'

import { useIntl } from 'react-intl'
import { makeStyles } from '@mui/styles'

import ClearIcon from '@mui/icons-material/Clear'
import { toPersianDigit } from '../../../helpers/generalHelpers'
import FieldWrapper from '../FieldRowWrapper'
import { isInternationalVersion } from 'settings/locale.settings'
import { shouldFlip } from 'stories/helpers/theme'

const useStyles = makeStyles((theme) => ({
  iconButton: {
    flip: shouldFlip(theme),
    left: -theme.spacing(1),
    padding: '12px 6px',
    '& svg': {
      fontSize: 15,
    },
  },
}))
export const DatePickerInput = ({
  label = '',
  name = '',
  placeholder,
  required,
  touched,
  error,
  description,
  from_date = '01/01/0100',
  to_date,
  value,
  onChange,
  onInputFocus,
  onInputBlur,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()

  useEffect(() => {
    moment.locale(isInternationalVersion() ? 'en' : 'fa')
  }, [])

  const changeDate = (date) => {
    const newValue = date ? moment(date).format('YYYY-MM-DD') : null
    onChange(newValue)
  }

  const getInputValue = () => {
    if (value) return moment(value).format('YYYY-MM-DD')
    return null
  }

  const labelFunc = (date) => {
    if (date) {
      return !isInternationalVersion()
        ? toPersianDigit(date.format('jYYYY/jMM/jDD'))
        : date.format('DD-MM-YYYY')
    }
    return ''
  }

  const datePickerUtils = isInternationalVersion()
    ? AdapterMoment
    : AdapterJalaali

  return (
    <FieldWrapper
      error={error}
      touched={touched ? touched.toString() : undefined}
    >
      <LocalizationProvider dateAdapter={datePickerUtils}>
        <DatePicker
          name={name}
          value={getInputValue()}
          clearLabel="clear"
          onChange={changeDate}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          labelFunc={labelFunc}
          label={label}
          minDate={from_date}
          maxDate={to_date}
          InputProps={{
            startAdornment: (
              <IconButton
                onClick={() => onChange(null)}
                className={classes.iconButton}
                size="large"
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
          renderInput={({ inputProps, ...restParams }) => (
            <TextField
              {...restParams}
              inputProps={{
                ...inputProps,
                placeholder:
                  placeholder ||
                  formatMessage({ id: 'form.fields.date.placeholder' }),
              }}
            />
          )}
        />
      </LocalizationProvider>
    </FieldWrapper>
  )
}
